module.exports = __webpack_public_path__ + "static/img/掌端APP_0.5f89ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/掌端APP_0.jpg
// module id = tju7
// module chunks = 1